import { ChangeEvent, useMemo, useState } from "react";

import { IUnlockCodeRow } from "../UnlockCodesTable";
import { generateCheckboxHeaderState } from "../utils";

const useSelectedIdsState = (unlockCodeData: IUnlockCodeRow[]) => {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const handleClearSelectedItems = () => {
    setSelectedIds(new Set());
  };

  const handleSelectAllCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedIds(prev =>
        // using 'as any' since TS 3.9 does not support Set Union operation
        (prev as any).union(
          new Set(unlockCodeData.map(unlockCodeObj => unlockCodeObj.id))
        )
      );
    } else {
      handleClearSelectedItems();
    }
  };

  const addSelectedId = (selectedId: string) => {
    // using 'as any' since TS 3.9 does not support Set Union operation
    setSelectedIds(prev => (prev as any).union(new Set([selectedId])));
  };

  const removeSelectedId = (removedId: string) => {
    setSelectedIds(
      // using 'as any' since TS 3.9 does not support Set Union operation
      prev => new Set((prev as any).values().filter(id => id !== removedId))
    );
  };

  const onRowCheckBoxClick = (unlockCodeId: string) => (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      addSelectedId(unlockCodeId);
    } else {
      removeSelectedId(unlockCodeId);
    }
  };

  const checkboxHeaderState = useMemo(
    () => generateCheckboxHeaderState(selectedIds, unlockCodeData),
    [selectedIds, unlockCodeData]
  );

  return {
    selectedIds,
    onRowCheckBoxClick,
    handleSelectAllCheckbox,
    checkboxHeaderState,
    handleClearSelectedItems
  };
};

export default useSelectedIdsState;
